import styled from 'styled-components'

import Colors from 'constants/colors'
import Threshold from 'constants/threshold'

export const PageDescription = styled.div`
  width: 100%;
  margin: auto;
  padding: 0 22px;
  max-width: 1060px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;

  @media (min-width: ${Threshold.phone}) {
    width: 74%;
    padding: 0;
    font-size: 20px;
    font-weight: 400;
    line-height: 35px;
  }
`

export const Name = styled.span`
  font-weight: 700;
`
export const Slash = styled.span`
  color: ${Colors.red};
`
